import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const toastMessageError = (response) => {
  const messageError =
    response.data && response.data.message
      ? response.data.message
      : "Houve um erro inesperado, tente novamente mais tarde.";

  return toast.error(messageError, {
    theme: "colored",
    closeButton: false,
  });
};

const toastMessageSuccess = (successMessage) => {
  return toast.success(successMessage, {
    theme: "colored",
    closeButton: false,
  });
};

const toastMessage = { toastMessageError, toastMessageSuccess };

export default toastMessage;
